import {
  LPU_FEATURE_DEFINITIONS,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuFeatures/constants'
import type { LpuFeature } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuFeatures/types'
import type { LpuInformation } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

/**
 * Собирает плоский список особенностей по флагам `lpu_information`.
 *
 * Учитывает boolean-флаги, `patient_group` и `special_conditions`.
 * Порядок — как в `LPU_FEATURE_DEFINITIONS` (легаси `profile/info.html`).
 */
export default function getLpuFeatures(
  lpuInformation?: LpuInformation | null,
): LpuFeature[] {
  if (!lpuInformation) {
    return []
  }

  const specialConditionKeys = new Set(
    (lpuInformation.special_conditions ?? [])
      .map(item => item.condition)
      .filter(Boolean),
  )

  return LPU_FEATURE_DEFINITIONS
    .filter(definition => {
      if (definition.kind === 'flag') {
        return Boolean(lpuInformation[definition.key])
      }

      if (definition.kind === 'patient_group') {
        return lpuInformation.patient_group === definition.key
      }

      return specialConditionKeys.has(definition.key)
    })
    .map(definition => ({
      key: definition.key,
      label: definition.label,
      iconSrc: definition.iconSrc,
    }))
}
